import React from "react";
import ConfirmationModal from "features/shared/components/confirmationModal";
import GoalPlanFormContainer from "features/goalPlan/views/shared/goalPlanForm/goalPlanFormContainer";
import { useTranslations } from "adapters/i18n";

const GoalsRegisterPage = ({
  onBack = () => { },
  onSubmit = () => { },
  showConfirmationModal,
  enableLoading,
  disableLoading,
  notifyError,
  farmId,
}) => {
  const { t } = useTranslations();
  const TEXT_TITLE = t("goalPlan:goal-registration");
  const TEXT_SUBTITLE = t("goalPlan:goal-registration-info");
  const TEXT_BUTTON_SUBMIT = t("goalPlan:save-goal");
  return (
    <GoalPlanFormContainer
      farmId={farmId}
      titlePage={t("goalPlan:create-new-goal-plan")}
      titleContent={TEXT_TITLE}
      subtitleContent={TEXT_SUBTITLE}
      onBack={onBack}
      onSubmit={onSubmit}
      enableLoading={enableLoading}
      disableLoading={disableLoading}
      notifyError={notifyError}
      textButtonSubmit={TEXT_BUTTON_SUBMIT}
    >
      {showConfirmationModal && (
        <ConfirmationModal
          title={showConfirmationModal.title}
          text={showConfirmationModal.text}
          submitButtonTitle={showConfirmationModal.buttonConfirmText}
          onSubmit={showConfirmationModal.onConfirm}
          onCancel={showConfirmationModal.onCancel}
        />
      )}
    </GoalPlanFormContainer>
  );
};

export default GoalsRegisterPage;
